import { AxiosError } from 'axios';
import { useQuery, useQueryClient } from 'react-query';
import { map as _map, filter as _filter } from 'lodash';

import { fetchDeals } from '../api';
import { QueryKeys, Deal, DealTile } from '../types';

export interface UseDealsProps {
  baseUrl: string;
  locale: string;
}

export const useDeals = ({ baseUrl, locale }: UseDealsProps) => {
  const filterDeals: any = (data: any, locale: string) => _filter(data, locale);
  const queryClient = useQueryClient();
  return useQuery<Deal[], AxiosError>([QueryKeys.Deals], () => fetchDeals(baseUrl), {
    staleTime: 60 * 1000,
    retry: false,
    select: data => {
      const filteredData = filterDeals(data, { locale });
      filteredData.forEach((fd: DealTile) => {
        if (fd.image && !fd.image.url.includes(baseUrl)) {
          const imagesUrl = fd.image.url.startsWith('/') ? fd.image.url.substring(1) : fd.image.url;
          fd.image.url = `${baseUrl}${imagesUrl}`;
        }
      });
      return filteredData;
    },
    onError: async () => {
      try {
        const data = await fetchDeals(``);
        queryClient.setQueryData([QueryKeys.Deals], [{ isErrored: true }, ...data]);
      } catch (error) {
        // Log the error with Sentry, the fallback failed.
      }
    },
  });
};
